import React from 'react';
import { withErrorBoundary } from 'component/common/Hoc/ErrorBoundary';
import { DisplaySectionName } from 'component/page/detail/DetailPageModularize/detailPageModularize.types';
import { LandingPageTopContents } from 'component/page/detail/DetailPageModularize/DisplaySections/LandingPageTopContents';
import { LandingPageMainContents } from 'component/page/detail/DetailPageModularize/DisplaySections/LandingPageMainContents';
import { InfoOverlayContents } from 'component/page/detail/DetailPageModularize/DisplaySections/InfoOverlayContents';
import { selectCategoryIdsFromDetailState, selectPageContentStatus } from 'component/page/detail/store/detail.selectors';
import { useSelector } from 'react-redux';
import { genericDetailPageConfig } from 'component/page/detail/DetailPageModularize/contentsConfigurations/genericDetailPageConfig';
import { simCardDetailPageConfig } from 'component/page/detail/DetailPageModularize/contentsConfigurations/simCardDetailPageConfig';
import { CategoryId } from 'core/type/Category.types';
import { isOn } from 'core/window/bootstrapConfig';
import { FeatureName } from 'core/constant/FeatureName';
import { PageContentStatus } from 'core/type/PageContentStatus';
import { Loader } from 'component/common/Loader/Loader';
import StandardErrorPage from 'component/page/error/ActivityStandardErrorPage';
import NoDetailsErrorPage from 'component/page/error/ActivityNoDetailsErrorPage';
import { selectCmsFromBootstrap } from 'store/slice/bootstrap';
import { Stack } from '@drone-js/core';

// this is the minimum height that can display full calendar
const DETAIL_PAGE_MIN_HEIGHT = '1100px';

const DetailPageModularizeComponent = ({ isDisableActivitiesForCnOrigin = false }) => {
    const pageStatus = useSelector(selectPageContentStatus);
    const categoryIds = useSelector(selectCategoryIdsFromDetailState);
    const cms = useSelector(selectCmsFromBootstrap);
    const isSimCard = categoryIds?.includes(CategoryId.SimCardsAndWifi);
    const isDetailPageForSimCardBehaviorEnabled = isOn(FeatureName.DetailPageForSimCard);
    const isSimCardDetailPage = isSimCard && isDetailPageForSimCardBehaviorEnabled;
    const pageConfig = isSimCardDetailPage ? simCardDetailPageConfig : genericDetailPageConfig;

    const isRedirectGenericErrorComponent = isOn(FeatureName.RedirectGenericErrorComponent);

    if (pageStatus === PageContentStatus.Loading) {
        return <Loader element="detail-page" />;
    }
    if (pageStatus === PageContentStatus.StandardError || isDisableActivitiesForCnOrigin) {
        return <StandardErrorPage page="details" contentStatus={pageStatus} isTargetToSearchPage={true} />;
    }

    if (pageStatus === PageContentStatus.SupplyError) {
        return isRedirectGenericErrorComponent ? (
            <StandardErrorPage page="details" contentStatus={pageStatus} isTargetToSearchPage={true} />
        ) : (
            <NoDetailsErrorPage error={cms[126985]} buttonText={cms[130767]} contentStatus={pageStatus} />
        );
    }

    return (
        <Stack direction="column" minHeight={DETAIL_PAGE_MIN_HEIGHT} data-testid="details-page">
            <LandingPageTopContents config={pageConfig[DisplaySectionName.LandingPageTop]} />
            <LandingPageMainContents config={pageConfig[DisplaySectionName.LandingPageMain]} />
            <InfoOverlayContents config={pageConfig[DisplaySectionName.InfoOverlay]} />
        </Stack>
    );
};

DetailPageModularizeComponent.displayName = 'DetailPageModularizeComponent';

export const DetailPageModularize = withErrorBoundary(DetailPageModularizeComponent);
